import DOMPurify from 'dompurify';

// Treat all stored, imported and generated rich text as untrusted. Keep ordinary
// article markup and media, but never embedded browsing contexts or active HTML.
export function sanitizeHTML(value) {
    return DOMPurify.sanitize(typeof value === 'string' ? value : '', {
        USE_PROFILES: { html: true },
        FORBID_TAGS: ['iframe', 'object', 'embed', 'style', 'form', 'input', 'button', 'textarea', 'select', 'link', 'meta', 'base'],
        FORBID_ATTR: ['style', 'srcdoc', 'autofocus', 'formaction', 'target'],
        SANITIZE_NAMED_PROPS: true,
    });
}
